(function () {
  function buildQuicklinksRow() {
    const productForm = document.querySelector('main product-form');
    if (!productForm || !productForm.parentElement) return;

    const row = document.createElement('div');
    row.className = 'product-quicklinks';
    let inserted = false;

    function ensureInserted() {
      if (inserted) return;
      inserted = true;
      productForm.parentElement.insertBefore(row, productForm);
    }

    const measurementsAccordion = document.querySelector('.product__accordion');
    if (measurementsAccordion) {
      const link = document.createElement('button');
      link.type = 'button';
      link.className = 'product-quicklinks__measurements';
      link.textContent = 'Zu den Maßen';
      link.addEventListener('click', () => {
        const details = measurementsAccordion.querySelector('details');
        if (details) details.open = true;
        measurementsAccordion.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      row.appendChild(link);
      ensureInserted();
    }

    function attachSizeToggle(toggle) {
      row.appendChild(toggle);
      ensureInserted();
    }

    const existingToggle = document.querySelector('[class*="size-toggle-template"]');
    if (existingToggle) {
      attachSizeToggle(existingToggle);
    } else {
      const observer = new MutationObserver(() => {
        const toggle = document.querySelector('[class*="size-toggle-template"]');
        if (toggle) {
          attachSizeToggle(toggle);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 8000);
    }
  }

  function buildAuthenticityBar() {
    const gallery = document.querySelector('main media-gallery');
    if (!gallery) return;

    const bar = document.createElement('div');
    bar.className = 'authenticity-bar';
    bar.innerHTML =
      '<span class="authenticity-bar__title">Echtheits-Garantie</span>' +
      '<button type="button" class="authenticity-bar__info" aria-expanded="false">' +
      'Mehr Infos' +
      '<span class="authenticity-bar__info-icon">i</span>' +
      '</button>';

    const overlay = document.createElement('div');
    overlay.className = 'authenticity-bar__overlay';
    overlay.hidden = true;

    const tooltip = document.createElement('div');
    tooltip.className = 'authenticity-bar__tooltip';
    tooltip.hidden = true;
    tooltip.textContent =
      'Jedes Teil wird vor dem Versand von uns auf Echtheit geprüft. Durch unsere Erfahrung mit Vintage-Markenware erkennen wir Fälschungen zuverlässig. So kannst du sicher sein, dass du bei uns immer ein zu 100 % originales Produkt bekommst.';

    const infoButton = bar.querySelector('.authenticity-bar__info');

    function toggle(show) {
      overlay.hidden = !show;
      tooltip.hidden = !show;
      infoButton.setAttribute('aria-expanded', String(show));
    }

    infoButton.addEventListener('click', () => toggle(tooltip.hidden));
    overlay.addEventListener('click', () => toggle(false));

    gallery.appendChild(bar);
    document.body.appendChild(overlay);
    document.body.appendChild(tooltip);
  }

  function updateTaxCaption() {
    const taxCaption = document.querySelector('main .product__tax');
    if (!taxCaption) return;
    taxCaption.textContent = 'inkl. MwSt. zzgl. Versandkosten';
  }

  function buildTrustBadges() {
    const firstAccordion = document.querySelector('.product__accordion');
    if (!firstAccordion || !firstAccordion.parentElement) return;

    const wrap = document.createElement('div');
    wrap.className = 'product-trust-badges';
    wrap.innerHTML =
      '<div class="product-trust-badges__item">' +
      '<span class="svg-wrapper">' + (window.__truckIcon || '') + '</span>' +
      '<span>Kostenloser Versand ab 75 €</span>' +
      '</div>' +
      '<div class="product-trust-badges__item">' +
      '<span class="svg-wrapper">' + (window.__returnIcon || '') + '</span>' +
      '<span>14 Tage Rückgaberecht</span>' +
      '</div>';

    firstAccordion.parentElement.insertBefore(wrap, firstAccordion);
  }

  function init() {
    buildQuicklinksRow();
    buildAuthenticityBar();
    updateTaxCaption();
    buildTrustBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
